export default __webpack_public_path__ + "static/media/logo.10153710.png";